// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article-carte-card-content {
    cursor: pointer;
}

.article-carte-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    flex-direction: row;
}

.article-carte-avatar {
    width: 30px;
    height: 30px;
    background: var(--gris-secondaire);
    color: var(--couleur-dark);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    z-index: 2;
    font-weight: 700;
}

.article-carte-user-name {
    font-size: var(--font-size-username);
    font-weight: var(--font-weight-title);
    color: var(--couleur-dark);
}

.article-carte-card-body {
    position: relative;
    background: var(--gris-secondaire);
    border-radius: 10px;
    overflow: hidden;
    width: 100%;
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.article-carte-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.article-carte-like-badge {
    position: absolute;
    top: 15px;
    right: 15px;
    background: var(--white-principale);
    color: var(--couleur-dark);
    padding: 6px 14px;
    border-radius: 20px;
    font-size: var(--font-size-badge);
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
}

.article-carte-like-badge i {
    transition: transform 0.2s ease;
}

.article-carte-like-badge i:hover {
    transform: scale(1.2);
}

.content_text_boost {
    position: absolute;
    top: 15px;
    left: 15px;
    background: var(--couleur-principale);
    color: var(--white-principale);
    padding: 6px 14px;
    border-radius: 20px;
    font-size: var(--font-size-badge);
}

.article-carte-footer {
    display: flex;
    flex-direction: column;
    align-items: left;
    margin-top: 15px;
    color: var(--couleur-dark);
}

.article-carte-title {
    font-size: var(--font-size-article-title);
    font-weight: var(--font-weight-medium);
}

.article-carte-price {
    font-size: var(--font-size-price);
    font-weight: var(--font-weight-price);
    color: var(--couleur-principale);
}

.article-carte-location {
    font-size: var(--font-size-location);
    font-weight: var(--font-weight-normal);
    letter-spacing: 0.5px;
    opacity: 0.7;
}

.article-carte-footer-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.article-carte-chat-btn {
    width: 50px;
    height: 50px;
    background: transparent;
    border: none;
    border-radius: 12px;
    font-size: 22px;
    cursor: pointer;
}

.article-carte-location-wrap {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.article-carte-etat {
    font-size: 11px;
    font-weight: 600;
    color: var(--couleur-secondaire);
    line-height: 1.2;
}

@media (min-width: 1025px) {
    .article-carte-card-content {
        width: 100%;
        flex: unset;
    }
}

@media (max-width: 768px) {
    .article-carte-card-content {
        width: 180px;
        flex: 0 0 180px;
    }

    .article-carte-card-body {
        height: 180px;
    }
}

@media (max-width: 480px) {
    .article-carte-card-content {
        width: 150px;
        flex: 0 0 150px;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/article/ArticleCarte.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mCAAmC;IACnC,0BAA0B;IAC1B,iBAAiB;IACjB,mBAAmB;IACnB,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,qCAAqC;IACrC,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,yCAAyC;IACzC,sCAAsC;AAC1C;;AAEA;IACI,iCAAiC;IACjC,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI;QACI,WAAW;QACX,WAAW;IACf;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;IACnB;AACJ","sourcesContent":[".article-carte-card-content {\n    cursor: pointer;\n}\n\n.article-carte-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 10px;\n    flex-direction: row;\n}\n\n.article-carte-avatar {\n    width: 30px;\n    height: 30px;\n    background: var(--gris-secondaire);\n    color: var(--couleur-dark);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 500;\n    z-index: 2;\n    font-weight: 700;\n}\n\n.article-carte-user-name {\n    font-size: var(--font-size-username);\n    font-weight: var(--font-weight-title);\n    color: var(--couleur-dark);\n}\n\n.article-carte-card-body {\n    position: relative;\n    background: var(--gris-secondaire);\n    border-radius: 10px;\n    overflow: hidden;\n    width: 100%;\n    height: 250px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.article-carte-img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.article-carte-like-badge {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    background: var(--white-principale);\n    color: var(--couleur-dark);\n    padding: 6px 14px;\n    border-radius: 20px;\n    font-size: var(--font-size-badge);\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    cursor: pointer;\n}\n\n.article-carte-like-badge i {\n    transition: transform 0.2s ease;\n}\n\n.article-carte-like-badge i:hover {\n    transform: scale(1.2);\n}\n\n.content_text_boost {\n    position: absolute;\n    top: 15px;\n    left: 15px;\n    background: var(--couleur-principale);\n    color: var(--white-principale);\n    padding: 6px 14px;\n    border-radius: 20px;\n    font-size: var(--font-size-badge);\n}\n\n.article-carte-footer {\n    display: flex;\n    flex-direction: column;\n    align-items: left;\n    margin-top: 15px;\n    color: var(--couleur-dark);\n}\n\n.article-carte-title {\n    font-size: var(--font-size-article-title);\n    font-weight: var(--font-weight-medium);\n}\n\n.article-carte-price {\n    font-size: var(--font-size-price);\n    font-weight: var(--font-weight-price);\n    color: var(--couleur-principale);\n}\n\n.article-carte-location {\n    font-size: var(--font-size-location);\n    font-weight: var(--font-weight-normal);\n    letter-spacing: 0.5px;\n    opacity: 0.7;\n}\n\n.article-carte-footer-bottom {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.article-carte-chat-btn {\n    width: 50px;\n    height: 50px;\n    background: transparent;\n    border: none;\n    border-radius: 12px;\n    font-size: 22px;\n    cursor: pointer;\n}\n\n.article-carte-location-wrap {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.article-carte-etat {\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--couleur-secondaire);\n    line-height: 1.2;\n}\n\n@media (min-width: 1025px) {\n    .article-carte-card-content {\n        width: 100%;\n        flex: unset;\n    }\n}\n\n@media (max-width: 768px) {\n    .article-carte-card-content {\n        width: 180px;\n        flex: 0 0 180px;\n    }\n\n    .article-carte-card-body {\n        height: 180px;\n    }\n}\n\n@media (max-width: 480px) {\n    .article-carte-card-content {\n        width: 150px;\n        flex: 0 0 150px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
